<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <v-btn v-if="inEditMode" class="ml-2 mr-2" color="primary" @click="saveClick(null)">
                    <v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
                </v-btn>
                <v-btn v-if="!inEditMode" class="ml-2 mr-2" color="primary" @click="editClick()">
                    <v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
                </v-btn>
                <v-btn class="mr-2" @click="backClick">
                    <v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" xl="3" lg="4" md="6">
                <v-card flat outlined>
                    <v-card-text>
                        <v-row dense wrap>
                            <v-col cols="12">
                                <CheckBox
                                    :readonly="!inEditMode"
                                    v-model="documentType.active"
                                    :label="$t('fields.active')"
                                ></CheckBox>
                            </v-col>
                            <v-col cols="12">
                                <InputField
                                    :readonly="!inEditMode"
                                    v-model="documentType.name"
                                    :errorBorder="!documentTypeValidation.name"
                                    :label="'* ' + $t('fields.documentType')"
                                ></InputField>
                            </v-col>
                            <v-col cols="12">
                                <Dropdown
                                    :readonly="!inEditMode"
                                    v-model="documentType.document_category_id"
                                    :ajax="true"
                                    :data="'document-categories'"
                                    :errorBorder="!documentTypeValidation.document_category_id"
                                    :label="'* ' + $t('fields.type')"
                                ></Dropdown>
                            </v-col>
                            <v-col cols="12">
                                <NumberField
                                    :min="0"
                                    :max="123"
                                    :readonly="!inEditMode"
                                    v-model="documentType.notify_before"
                                    :label="'* ' + $t('fields.notifyBeforeDays')"
                                ></NumberField>
                            </v-col>
                            <v-col cols="12">
                                <CheckBox
                                    :readonly="!inEditMode"
                                    v-model="documentType.notify"
                                    :label="$t('fields.notify')"
                                ></CheckBox>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import CheckBox from './trinkets/CheckBox';
import Dropdown from './trinkets/Dropdown';
import InputField from './trinkets/InputField';
import NumberField from './trinkets/NumberField';
import DocumentType from '../models/DocumentType';

export default {
    name: 'DocumentType',
    components: {CheckBox, Dropdown, InputField, NumberField},
    data: function () {
        return {
            documentType: new DocumentType({id: this.$route.params.id}),
            documentTypeValidation: new DocumentType({}, true),
            initialLoad: false,
            inEditMode: false,
            lockKey: 'document-type',
            lockTimer: null,
        };
    },
    methods: {
        editClick() {
            let vm = this;
            this.$setLock(this, this.lockKey + '|' + this.documentType.id, (data) => {
                if (data.success) {
                    vm.inEditMode = true;
                    vm.lockTimer = setInterval(() => {
                        vm.$setLock(vm, vm.lockKey + '|' + vm.documentType.id);
                    }, 10000);
                } else {
                    vm.$alert(
                        this.$t('alerts.recordLocked')
                            .split('%name%')
                            .join(data.locked_by.first_name + ' ' + data.locked_by.last_name),
                    );
                }
            });
        },
        backClick() {
            this.$router.go(-1);
        },
        saveClick(after = null) {
            let success = true;
            if (this.documentType.name == '') {
                success = false;
                this.documentTypeValidation.name = false;
            } else {
                this.documentTypeValidation.name = true;
            }

            if (this.documentType.document_category_id == null) {
                success = false;
                this.documentTypeValidation.document_category_id = false;
            } else {
                this.documentTypeValidation.document_category_id = true;
            }
            if (success) {
                let vm = this;
                let action = 'post';
                let addition = '';
                if (vm.documentType.id != 0) {
                    action = 'put';
                    addition = '/' + vm.documentType.id;
                }
                this.$APICall(action, 'document-types' + addition, this.documentType, (data, success) => {
                    if (success) {
                        vm.inEditMode = false;
                        if (vm.documentType.id == 0) {
                            vm.$notify(vm.$t('alerts.basicAdd'));
                        } else {
                            vm.$notify(vm.$t('alerts.basicUpdate'));
                        }
                        if (this.lockTimer !== null) clearInterval(this.lockTimer);
                        this.$removeLock(this, this.lockKey + '|' + this.documentType.id);
                        vm.$triggerReload();
                        if (after !== null) {
                            after();
                        } else {
                            vm.backClick();
                        }
                    }
                });
            }
        },
    },
    beforeRouteLeave(to, from, next) {
        if (this.inEditMode) {
            let vm = this;
            this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
                if (result) {
                    if (vm.lockTimer !== null) clearInterval(this.lockTimer);
                    vm.$removeLock(vm, vm.lockKey + '|' + vm.documentType.id);
                    next(true);
                } else {
                    next(false);
                }
            });
        } else {
            next(true);
        }
    },
    mounted() {
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        let vm = this;
        if (this.documentType.id != 0) {
            this.$APICall('get', 'document-types/' + this.documentType.id, {}, (data, success) => {
                if (success) {
                    let usableData = JSON.parse(JSON.stringify(data));
                    vm.documentType = usableData;
                    vm.$myStore.commit('setBreadcrumbs', [
                        {
                            text: vm.$t('modules.documentTypes'),
                            href: '/#/document-types',
                            disabled: false,
                        },
                        {
                            text: vm.documentType.name,
                            href: '/#/document-types/' + vm.documentType.id,
                            disabled: true,
                        },
                    ]);
                    vm.$nextTick(() => {
                        vm.initialLoad = true;
                    });
                }
            });
        } else {
            this.$myStore.commit('setBreadcrumbs', [
                {
                    text: this.$t('modules.documentTypes'),
                    href: '/#/document-types',
                    disabled: false,
                },
                {
                    text: this.$t('modules.newDocumentType'),
                    href: '/#/document-types/0',
                    disabled: true,
                },
            ]);
            this.inEditMode = true;
            this.initialLoad = true;
        }
    },
};
</script>

<style scoped></style>
